import { useCountdown } from "../../../utils/countdown";
 
/**
 * CountdownGate
 *
 * Props:
 *   seconds       number   — how long to count down (default: 30)
 *   pendingText   string   — text shown during countdown; use "{countdown}" as placeholder
 *   children      node     — content revealed after the countdown expires
 *
 * Example:
 *   <CountdownGate
 *     seconds={30}
 *     pendingText="Request a new code in {countdown}"
 *   >
 *     <button onClick={handleResend}>Resend code</button>
 *   </CountdownGate>
 */
export default function CountdownConditional({
  seconds = 30,
  pendingText = "Request a new code in {countdown}",
  children,
}) {
  const { remaining, formatted, reset } = useCountdown(seconds);
 
  if (remaining > 0) {
    const parts = pendingText.split("{countdown}");
    return (
      <span>
        {parts[0]}{formatted}{parts[1]}
      </span>
    );
  }
 
  // Clone children and inject `reset` so they can restart the timer
  return (
    <>
      {typeof children === "function"
        ? children({ resetCountdown: reset })
        : children}
    </>
  );
}